import { OvlAddScreen } from "../../../_ovlclient/src/global/globals"
import { ScreenSYSAudit } from "./screens/audit"

export const SYSAudit_Init = () => {
  OvlAddScreen(ScreenSYSAudit, "SYSAudit")
}
